<template>
  <div id="cardMercadoPago">
    <div class="container paymentCard">
      <!-- <div class="cart-header">
        <b-button icon-left="times" style="border: inherit;float: right;" class="cart-header-btn-close" @click="$parent.close()"></b-button>
      </div> -->
      <!-- <div class="title-payment">
        <div class="arrow" @click="$parent.close()">
           <i style="color:black" class="fas fa-arrow-left"></i>
        </div>
        <span class="text bold segoe size-23 margin-bot-10">Finaliza tu pedido</span>
      </div> -->
      <form class="cont" @submit.prevent="validateBeforeCard" id="pay" name="pay">
        <input type="hidden" name="token" id="token" value="">
        <div class="columns">
          <div class="column">
            <!-- <div class="pay-cont">
                <span class="text bold segoe size-16"><i class="fas fa-credit-card"></i>  Tarjeta de crédito</span>
                <b-radio v-model="radioCard"
                native-value="0">
                </b-radio>
            </div>
            <div class="pay-cont">
                <span class="text bold segoe size-16"> <i class="far fa-credit-card"></i>  Tarjeta débito</span>
                <b-radio disabled v-model="radioCard"
                    native-value="1">
                </b-radio>
            </div> -->
            <b-field label="Titular de la tarjeta:" :type="{'is-danger': errors.has('cardholderName')}" :message="errors.first('cardholderName')">
              <b-input type="text"
                  v-model="card.payer.first_name"
                  placeholder="Nombre del titular"
                  v-validate="'required|min:2'"
                  id="cardholderName"
                  data-checkout="cardholderName"
                  icon-pack="fa" icon=""></b-input>
            </b-field>
            <div style="display:flex">
            <b-field style="min-width:100px;width: 100px;margin-right: 10px;" label="Tipo de id*" :type="{'is-danger': errors.has('docType')}" :message="errors.first('docType')">
                <b-select v-model="card.payer.identification.type" id="docType" name="docType" data-checkout="docType" placeholder="Tipo id" v-validate="'required'" expanded>
                  <option v-for="identi in identification" :value="identi.id" :key="identi.id">{{ identi.name }}</option>
                </b-select>
            </b-field>
            <b-field  style="width:100%" label="Identificación: " :type="{'is-danger': errors.has('docNumber')}" :message="errors.first('docNumber')">
              <b-input type="text"
                  v-model="card.payer.identification.number"
                  @input="card.payer.identification.number = card.payer.identification.number.replace(/[^a-zA-Z0-9]/g, '')"
                  placeholder="Documento de identidad"
                  autocomplete="off"
                  id="docNumber"
                  data-checkout="docNumber"
                  v-validate="'required|alpha_num|min:5'" icon-pack="fa" icon=""></b-input>
            </b-field>
            </div>
            <b-field label="Email:" :type="{'is-danger': errors.has('email')}" :message="errors.first('email')">
              <b-input
                type="email"
                name="email"
                id="email"
                v-model="card.payer.email"
                placeholder="Email"
                v-validate="'required|email'" icon-pack="fa" icon=""></b-input>
            </b-field>
          </div>
          <div class="column border-left">
            <span class="text bold segoe size-11">Datos tarjeta</span>
            <!-- Mercado Pago Secure Fields (v2): número, vencimiento y CVC viven en iframes del SDK de
                 Mercado Pago; este componente nunca los ve, solo recibe un token. -->
            <div class="mp2-label">Numero de la tarjeta:</div>
            <div class="mp2-field" id="mpCardNumber"></div>
            <div class="mp2-label">Vencimiento:</div>
            <div class="mp2-field" id="mpExpirationDate"></div>
            <div class="mp2-label">Código de seguridad:</div>
            <div class="mp2-field" id="mpSecurityCode"></div>
            <div class="columns wrap">
              <b-field label="Nro Cuota:" class="column" :type="{'is-danger': errors.has('cuota')}" :message="errors.first('cuota')">
              <b-select name="cuota" v-model="card.installments" placeholder="Seleccione" v-validate="'required'" expanded>
                <option v-for="cuota in cuotas" :value="cuota.value" :key="cuota.value">{{ cuota.label }}</option>
              </b-select>
            </b-field>
            </div>
            <div class="furute-box" v-if="false">
              Deseas guardar esta tarjeta para compras futuras
              <b-switch :value="true" id="saveCard" name="saveCard" checked="true" v-model="checked" type="is-success"></b-switch>
            </div>
          </div>
        </div>
        <div class="terms pay">
          <div class="copy-terms">
            <b-checkbox class="terms-label" v-model="authTerms"></b-checkbox>&nbsp; <span class="text segoe">Al dar clic en "Pagar" declara que conoce y acepta el tratamiento de datos personales previamente informado y al enviar este formato a Precompro acepta nuestros </span>
            <a @click="showTerms = true" class="link-terms">Términos y condiciones y la Política de Privacidad*</a>.
           <span class="test segoe">Para cumplir con el objeto social de Precompro, al hacer la reserva se compartirá su información con el restaurante aliado. </span>
          </div>
        </div>
        <div class="columns">
          <div class="column bottom-text">
          </div>
          <div class="column bottom-text-r padding-500"
            style="margin-right: 0px; text-align: right; padding: 30px 0px 0px 0px;">
            <span class="text segoe" style="vertical-align: super;"> Pagos seguros a través de</span> &nbsp;<img src="@/assets/image/mercadoPago.svg" style="width: 2.5rem; margin-right: 10px; margin-left: 10px;">
          </div>
        </div>
        <div id="modal-terms">
          <b-modal :active.sync="showTerms">
            <div class="terms-body">
              <h3 class="title-modal">Política Tratamiento de Datos Personales de Click2buy S.A.S.</h3>
              <terms :fecha="'22 de Noviembre del 2019'"></terms>
            </div>
          </b-modal>
        </div>
        <div class="row">
          <div class="col-12" style="padding-bottom: 30px;display: flex;justify-content: center;">
              <button type="submit"
                class="btn btn-reserva-disabled"
                :disabled="(loader || !authTerms)"
                :class="{'opacity06':(card.payer.first_name === null || card.payer.first_name === ''||
                  card.payer.identification.type === null || card.payer.identification.type === '' ||
                  card.payer.identification.number === null || card.payer.identification.number === '' ||
                  card.payer.email === null || card.payer.email === '' ||

                  card.installments === null || card.installments === '' || (errors.items.length > 0))}"
              >
                <span class="text size-18 family-bold">Realizar pago</span>
              </button>
            </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import terms from '@/components/Terms';
import { mapGetters } from 'vuex';
import llaveMercadoPago from '@/helpers/llaveMercadoPago';
export default {
  components: { terms },
  props: ['order'],
  data () {
    return {
      masks: {
        creditCard: { creditCard: true },
        custom: {
          numericOnly: true
        }
      },
      authTerms: true,
      showTerms: false,
      mercadopago: null,
      bin: null,
      checked: true,
      doSubmit: false,
      card: {
        payer: {
          first_name: null,
          identification: {
            type: null,
            number: null
          },
          email: null
        },
        token: null,
        installments: null,
        description: null,
        payment_method_id: null,
        transaction_amount: 0,
        net_amount: 0,
        binary_mode: true,
        taxes: [
          {
            value: 0,
            type: 'IVA'
          }
        ]
      },
      identification: [],
      meses: [
        { value: '01', label: '01' },
        { value: '02', label: '02' },
        { value: '03', label: '03' },
        { value: '04', label: '04' },
        { value: '05', label: '05' },
        { value: '06', label: '06' },
        { value: '07', label: '07' },
        { value: '08', label: '08' },
        { value: '09', label: '09' },
        { value: '10', label: '10' },
        { value: '11', label: '11' },
        { value: '12', label: '12' }
      ],
      anos: [
        { value: '20', label: '20' },
        { value: '21', label: '21' },
        { value: '22', label: '22' },
        { value: '23', label: '23' },
        { value: '24', label: '24' },
        { value: '25', label: '25' },
        { value: '26', label: '26' },
        { value: '27', label: '27' },
        { value: '28', label: '28' },
        { value: '29', label: '29' },
        { value: '30', label: '30' },
        { value: '31', label: '31' },
        { value: '32', label: '32' },
        { value: '33', label: '33' },
        { value: '34', label: '34' },
        { value: '35', label: '35' }
      ],
      cuotas: [
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5' },
        { value: 6, label: '6' },
        { value: 7, label: '7' },
        { value: 8, label: '8' },
        { value: 9, label: '9' },
        { value: 10, label: '10' },
        { value: 11, label: '11' },
        { value: 12, label: '12' }
      ],
      cuotasDefault: [
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5' },
        { value: 6, label: '6' },
        { value: 7, label: '7' },
        { value: 8, label: '8' },
        { value: 9, label: '9' },
        { value: 10, label: '10' },
        { value: 11, label: '11' },
        { value: 12, label: '12' }
      ],
      radioCard: 0
    };
  },
  computed: {
    ...mapGetters([
      'loader',
      'getVendor'
    ])
  },
  created () {
    // Los campos del SDK no se hacen reactivos a proposito.
    this.campos = [];
  },
  mounted () {
    this.card.transaction_amount = this.order.totalPrice + this.order.delivery;
    this.card.net_amount = this.order.totalPrice + this.order.delivery;
    this.getIdentification();
    this.iniciarMercadoPago();
  },
  beforeDestroy () {
    this.campos.forEach((c) => { try { c.unmount(); } catch (e) { /* ya desmontado */ } });
  },
  methods: {
    selectPayment () {
      this.$store.commit('setPaymentType', false);
    },
    // La llave publica llega del backend: se espera antes de crear el SDK. Sin llave, aviso y no se rompe la pantalla.
    async iniciarMercadoPago () {
      const vendorId = (this.getVendor && this.getVendor.id) || (this.order.vendor && this.order.vendor.id);
      const llave = await llaveMercadoPago(vendorId);
      if (!llave) {
        this.$buefy.dialog.alert({
          message: 'El pago con tarjeta no está disponible en este momento. Intenta con otro medio de pago.',
          confirmText: 'Aceptar'
        });
        return;
      }
      // eslint-disable-next-line
      this.mercadopago = new MercadoPago(llave);
      this.setConfigMercadoPago();
    },
    // Monta los tres campos seguros. Mismo patron que `categories/creditCardPayment.vue` (type 'MP').
    setConfigMercadoPago () {
      const root = document.documentElement;
      const inputBg = getComputedStyle(root).getPropertyValue('--orderInputBackground').trim() || '#fff';
      const inputColor = getComputedStyle(root).getPropertyValue('--orderInputTextColor').trim() || '#444b57';
      const mpStyle = {
        color: inputColor,
        'background-color': inputBg,
        'font-size': '12px',
        'font-family': 'Source Sans Pro, sans-serif',
        placeholder: { color: inputColor + '80' }
      };
      const cardNumberElement = this.mercadopago.fields.create('cardNumber', {
        placeholder: 'Número de la tarjeta',
        style: mpStyle
      }).mount('mpCardNumber');
      const expiracion = this.mercadopago.fields.create('expirationDate', {
        placeholder: 'MM/YY',
        style: mpStyle
      }).mount('mpExpirationDate');
      const cvv = this.mercadopago.fields.create('securityCode', {
        placeholder: 'CVV',
        style: mpStyle
      }).mount('mpSecurityCode');
      this.campos = [cardNumberElement, expiracion, cvv];
      cardNumberElement.on('binChange', this.getPaymentMethods);
    },
    validateBeforeCard () {
      this.errors.clear();
      this.$validator.validateAll().then(async result => {
        if (!result) return;
        this.$store.commit('setLoader', true);
        try {
          const token = await this.mercadopago.fields.createCardToken({
            cardholderName: this.card.payer.first_name,
            identificationType: this.card.payer.identification.type,
            identificationNumber: this.card.payer.identification.number
          });
          this.card.token = token.id;
        } catch (e) {
          this.$store.commit('setLoader', false);
          this.$buefy.dialog.alert({
            message: 'Revisa los datos de la tarjeta e intenta de nuevo',
            confirmText: 'Aceptar'
          });
          return;
        }
        this.proccessCard();
      });
    },
    proccessCard () {
      this.$store.commit('setLoader', true);
      this.order.mp = 1;
      this.$http.post('marketplace/payment/card', { order: this.order, cardCredit: this.card }).then(({ data }) => {
        if (data.code === 705 || data.code === 706) {
          this.$emit('cancelTransactionCard', true);
        }
        if (data.code === 780) {
          this.$emit('pendingTransactionCard', true);
        }
        if (data.code === 200) {
          this.$store.commit('setPaymentType', false);
          this.$store.commit('setCart', []);
          this.$emit('approvedTransactionCard', data.data ? data.data.orderId : data.orderId);
        }
        this.$store.commit('setLoader', false);
      }).catch(() => {
        this.$store.commit('setLoader', false);
        this.$buefy.toast.open({
          duration: 5000,
          message: "<i class='fa fa-exclamation-circle alerticon'></i>&nbsp;Ocurrio un error al procesar la petición con la pasarela de pago <br><strong style='color: #ffffff;'>Intenta realizar el pago de nuevo</strong> ",
          type: 'is-danger',
          position: 'is-bottom',
          queue: false
        });
      });
    },
    getPaymentMethods (data) {
      const { bin } = data;
      if (bin != null && bin !== undefined) {
        this.mercadopago.getPaymentMethods({ bin }).then(({ results }) => {
          this.bin = bin;
          this.card.payment_method_id = results[0].id;
          this.getInstallments(bin);
        });
      } else {
        this.bin = null;
        this.card.payment_method_id = null;
        this.cuotas = this.cuotasDefault;
      }
    },
    getInstallments (bin) {
      this.mercadopago.getInstallments({
        amount: String(this.card.transaction_amount),
        bin,
        paymentTypeId: 'credit_card'
      }).then((installments) => {
        if (installments[0]) {
          this.cuotas = installments[0].payer_costs.map(installment => ({
            label: installment.recommended_message,
            value: installment.installments
          }));
        } else {
          this.cuotas = this.cuotasDefault;
        }
      }).catch(() => {
        this.cuotas = this.cuotasDefault;
      });
    },
    getIdentification () {
      this.$http.get('marketplace/payment/identifications').then(({ data }) => {
        if (data.code === 200) {
          this.identification = data.data;
        }
      });
    }
  }
};
</script>
<style lang="scss">
#cardMercadoPago{
  .mp2-label { font-size: 12px; margin: 8px 0 4px; }
  .mp2-field {
    height: 32px;
    border: 1px solid var(--orderInputBorderColor, rgba(3, 15, 52, 0.42));
    border-radius: 9px;
    background: var(--orderInputBackground, #fff);
    padding: 0 10px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
.paymentCard {
 padding: 0 15px;
 .field:not(:last-child) {
   margin-bottom: inherit;
}
  //new scss
  .arrow{
    position: absolute;
    left: -8px;
  }
  .cont{
        display: flex;
    flex-direction: column;
    padding: 0 15px;
    input{
      box-shadow: inherit;
    border-radius: 9px;
    height: 32px;
    font-size: 10px;
    font-family: segoe;
    padding: 0 10px;
    border: 1px solid var(--orderInputBorderColor, rgba(3, 15, 52, 0.42));
    text-align: left;
    color: var(--orderInputTextColor, black);
    background: var(--orderInputBackground, #fff);
    }
    select{
      box-shadow: inherit;
    border-radius: 9px;
    height: 32px;
    font-size: 10px;
    font-family: segoe;
    padding: 0 10px;
    border: 1px solid var(--orderInputBorderColor, rgba(3, 15, 52, 0.42));
    text-align: left;
    color: var(--orderInputTextColor, black);
    background: var(--orderInputBackground, #fff);
    }
    .columns{
      &.wrap{
        flex-wrap: wrap;
        display: flex;
      }
    }
    .column{
      &.border-bot{
            border-bottom: 1.5px solid rgba(207, 205, 205, 0.6);
      }
    }
  }
  .title-payment{
    width: calc(100% - 30px);
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    margin: 0 15px;
    border-bottom: 1.5px solid rgba(207, 205, 205, 0.6);
  }
    .pay-cont{
        display: flex;
        justify-content: space-between;
        margin: 15px 0;
    }
    // end scss

  .furute-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 48px;
  }
  .back_method {
    color: var(--orderTextColor, #000) !important;
    font-size: 14px;
    margin-top: 20px;
  }

  .terms-link {
    padding-left: 0;
    font-size: 14px;
    display: flex;
    align-items: flex-end;
  }
  .header-paytitle {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
    .img-paymns {
      display: flex;
      align-items: center;
      img {
        margin: 3px;
      }
    }
    .title-pymen {
      font-weight: bold;
      font-size: 20px;
      i {
        margin-right: 5px;
      }
    }
  }
  .title-type {
    margin-bottom: 25px;
    font-weight: bold;
    font-size: 15px;
    margin-top: 5px;
  }
  .input,
  .taginput .taginput-container.is-focusable,
  .textarea {
    text-align: right;
  }

  .field-label.is-normal label.label {
    font-family: normal;
    font-size: 12px;
    text-align: left;
    font-weight: 100;
    height: 100%;
    padding-top: 5px;
  }
  .field-label.is-normal {
    padding-top: 0 !important;
    margin-right: 10px !important;
  }
  .hsy-dropdown > .list {
    width: 100% !important;
  }
  .hsy-dropdown > .selected {
    background-position: 96% center, center center !important;
    height: 33px !important;
    border: 1px solid var(--orderInputBorderColor, #ccc) !important;
  }
  .list {
    height: 20vh;
    overflow: scroll;
  }
  .img-card {
    height: 0.75rem;
    display: flex;
  }
  .img-card2 {
    height: 1rem;
    display: flex;
  }
  .inputTrans {
    background: var(--orderInputBackground, transparent);
    border-radius: 5px;
    border: 1px solid var(--orderInputBorderColor, lightgray);
    color: var(--orderInputTextColor, #000);
    width: 100%;
    text-align: right;
    padding: 4px 10px;
    font-size: 14px;
    margin: 2px 0px;
  }
  .opacity06 {
    opacity: 0.6;
  }
  .btn{
    &.btn-reserva-disabled{
    height: 40px;
    background: var(--orderBtnBackground, var(--buttonBackground));
    color: var(--orderBtnTextColor, var(--buttonTextColor)) !important;
    .text{
          color: var(--orderBtnTextColor, var(--buttonTextColor)) !important;
    }
    width: 100%;
    max-width: 360px;
    border-radius: 6px;
    border: inherit;
    cursor: pointer;
    }
  }
  @media (min-width: 768px) {
    .m-left-10-mq {
      margin-left: -10px;
    }
    .check-top {
      margin-top: 60px;
    }
    .border-left {
      border-left: 1px solid var(--orderInputBorderColor, lightgray);
    }
  }
  .selectedCard {
    border: 1px solid var(--orderTextColor, #000);
    border-radius: 5px;
    padding: 5px;
  }
}

@media (max-width: 767px) {
  .metohpayment {
    background-color: var(--orderPageBackground, white);
    padding: 30px 30px !important;
  }
  .verticals {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row !important;
    padding: 10px !important;
  }

  .vertical-line {
    background: #ddd !important;
    width: 50% !important;
    height: 2px !important;
  }

  .padding-top20 {
    padding-top: 40px;
    padding: 40px 20px 10px;
    text-align: center;
  }
  .texter {
    font-weight: 500;
    color: #999;
    i {
      margin-right: 5px;
    }
  }
  .vertical-o {
    background: #fff;
    width: auto;
    height: 20px;
    display: flex;
    line-height: 17px;
    padding: 0 30px;
  }
}
.bottom-text, .bottom-text-r {
  font-size: 15px;
  -webkit-box-align: end;
  align-items: flex-end;
  display: -webkit-box;
  display: flex;
  padding: 5px;
  justify-content: flex-end;
}
.bottom-text {
  -webkit-box-pack: start;
  justify-content: flex-start;
}
}
</style>
